import { useTranslation } from "react-i18next";
import moment from "moment-jalaali";

import jalali from "react-date-object/calendars/jalali";
import gregorian from "react-date-object/calendars/gregorian";
import arabic from "react-date-object/calendars/arabic";

import jalali_fa from "react-date-object/locales/persian_fa";
import gregorian_en from "react-date-object/locales/gregorian_en";
import arabic_ar from "react-date-object/locales/arabic_ar";

export const useCalendarConfig = () => {
  const { i18n } = useTranslation();
  const currentLanguage = i18n.language || "fa";

  const getCalendarConfig = () => {
    switch (currentLanguage) {
      case "fa":
        return {
          calendar: jalali,
          locale: jalali_fa,
          momentLocale: "fa",
          format: "YYYY-MM-DD",
          yearFormat: "YYYY",
          dir: "rtl" as const,
          placeholder: "انتخاب تاریخ",
          clearLabel: "پاک کردن",
        };
      case "ar":
        return {
          calendar: arabic,
          locale: arabic_ar,
          momentLocale: "ar",
          format: "YYYY-MM-DD",
          yearFormat: "YYYY",
          dir: "rtl" as const,
          placeholder: "اختر التاريخ",
          clearLabel: "مسح",
        };
      default:
        return {
          calendar: gregorian,
          locale: gregorian_en,
          momentLocale: "en",
          format: "YYYY-MM-DD",
          yearFormat: "YYYY",
          dir: "ltr" as const,
          placeholder: "Select date",
          clearLabel: "Clear",
        };
    }
  };

  const config = getCalendarConfig();

  moment.locale(config.momentLocale);

  // year
  const getCurrentYear = (): number => {
    switch (currentLanguage) {
      case "fa":
        return moment().jYear();
      case "ar":
        return moment().year();
      default:
        return moment().year();
    }
  };

  const getYears = (): number[] => {
    const currentYear = getCurrentYear();
    return [currentYear - 1, currentYear - 2, currentYear - 3];
  };

  const getYearLabel = (year: number): string => {
    return year.toString();
  };

  const getGregorianYear = (solarYear: number): number => {
    return solarYear + 621;
  };

  const getSolarYear = (gregorianYear: number): number => {
    return gregorianYear - 621;
  };

  return {
    calendar: config.calendar,
    locale: config.locale,
    format: config.format,
    yearFormat: config.yearFormat,
    dir: config.dir,
    momentLocale: config.momentLocale,
    placeholder: config.placeholder,
    clearLabel: config.clearLabel,
    currentLanguage,
    isPersian: currentLanguage === "fa",
    isArabic: currentLanguage === "ar",
    isEnglish: currentLanguage === "en",
    getYears,
    getYearLabel,
    getGregorianYear,
    getSolarYear,
  };
};
